import api from "../../api/api";

export const getAllProgramTypes = async (data) =>
  await api.get(`getAllTrainingTypes/${data.usertype}/${data.language}`);

export const getAllModules = async (data) => {
  const response = await api.get(
    `getAllModules/${data.trainingType}/${data.usertype}/${data.language}`
  );
  if (response.data && Array.isArray(response.data)) {
    // Dynamically import getMediaUrl to avoid circular dependency issues if any
    const { getMediaUrl } = require("../../utils/mediaUtils");
    response.data = response.data.map((module) => ({
      ...module,
      moduleImage: getMediaUrl(module.moduleImage),
    }));
  }
  return response;
};

export const getAllsubModules = async (data) =>
  await api.get(
    `getAllSubmodulesByModuleId/${data.trainingType}/${data.usertype}/${data.language}/${data.moduleid}`
  );

export const getAllTopics = async (data) =>
  await api.get(
    `getAllTopicsBySubmoduleId/${data.usertype}/${data.trainingType}/${data.language}/${data.moduleid}/${data.submoduleid}`
  );

export const getAllContents = async (data) => {
  const response = await api.get(`getMasterTchTrainingContent/${data.topicId}`);
  
  if (response.data && Array.isArray(response.data)) {
    response.data = response.data.map(item => {
      // Scrub 'undefined/undefined/' or any legacy backend prepend from the URLs
      if (item.value) {
        if (typeof item.value === 'string' && item.value.includes('http')) {
          item.value = item.value.substring(item.value.indexOf('http'));
        } else if (Array.isArray(item.value)) {
          item.value = item.value.map(val => (typeof val === 'string' && val.includes('http') ? val.substring(val.indexOf('http')) : val));
        }
      }
      if (item.thumbnail && typeof item.thumbnail === 'string' && item.thumbnail.includes('http')) {
        item.thumbnail = item.thumbnail.substring(item.thumbnail.indexOf('http'));
      }
      return item;
    });
  }
  return response;
};

//! This is being used inside the templateCreator thunk
export const createContents = async (data) => {
  await api.post(`/saveMasterTchTrainingContent`, data);
};

export const updatePptContent = async (data) =>
  await api.put(`updateMasterTchTrainingContent`, data);

export const createPptContent = async (data) =>
  await api.put(`updateMasterContentQuizData`, data);

export const createQuizContent = async (data) =>
  await api.post(`saveMasterTchTrainingQuiz`, data);

//Fetch all the quizes---------->
export const getAllQuizes = async (data) =>
  await api.get(`getMasterTchTrainingQuiz/${data.topicId}/${data.quizType}`);

//Delete all the contents--------
export const deleteAllContents = async (data) =>
  await api.delete(`deleteMasterTchTrainingContent/${data.topicId}/`);

export const updateAllQuiz = async (data) => {
  await api.put(`updateMasterTchTrainingQuiz`, data);
};

export const deleteQuiz = async (data) => {
  await api.delete(
    `deleteMasterTchTrainingQuiz/${data.topicId}/${data.quizType}`
  );
};

export const createLink = async (data) => {
  await api.post(`/saveMasterTchTrainingContentReferenceData`, data);
};
export const getLink = async (data2) => {
  return await api.get(
    `getMasterTchTrainingContentReferenceData/${data2.topicId}/reference`
  );
};
export const deleteLink = async (data) =>
  await api.delete(
    `deleteMasterTchTrainingContentReferenceData/${data.topicId}/reference`
  );
export const updateLink = async (data) => {
  await api.put(`updateMasterTchTrainingContentReferenceData  `, data);
};
